module.exports = __webpack_public_path__ + "images/category_lp/art_work/store_images/1_3498aceced13fe9714acbb3daf3cf532.png";